import React, { Component } from 'react'
import moment from 'moment'

import TimeAgo from 'timeago-react';
import * as timeago from 'timeago.js';
import 'moment/locale/vi';
export const cms = (number, index, totalSec) => {
  // number: the time ago / time in number;
  // index: the index of array below;
  // totalSec: total seconds between date to be formatted and today's date;

  if (index === 5) {
    // console.log(totalSec, number)
  }

  return [
    ['vừa xong', 'một lúc'],
    ['%s giây trước', 'trong %s giây'],
    ['1 phút trước', 'trong 1 phút'],
    ['%s phút trước', 'trong %s phút'],
    ['1 giờ trước', 'trong 1 giờ'],
    ['%s giờ trước', 'trong %s giờ'],
    ['1 ngày trước', 'trong 1 ngày'],
    ['%s ngày trước', 'trong %s ngày'],
    ['1 tuần trước', 'trong 1 tuần'],
    ['%s tuần trước', 'trong %s tuần'],
    ['1 tháng trước', 'trong 1 tháng'],
    ['%s tháng trước', 'trong %s tháng'],
    ['1 năm trước', 'trong 1 năm'],
    ['%s năm trước', 'trong %s năm'],
  ][index];
}


class Date extends Component {
  convertDate(value) {
    let dateNow = moment();
    let diffTime = moment(value);
    let diffHour = dateNow.diff(diffTime, 'hours');
    let diffDay = dateNow.diff(diffTime, 'days');

    let time = '';
    if (diffHour > 1) {
      if (diffHour >= 1 && diffHour < 24) {
        time = moment(diffTime).format('LT')
      }
      if (diffDay >= 1 && diffDay < 7) {
        time = moment(diffTime).format('dddd')
      }
      if (diffDay >= 7) {
        time = moment(diffTime).format('LL').split('năm')[0]
      }
    }

    return time
  }

  renderTime(time) {
    const now = moment();
    const then = moment(time);
    if (now.year() === then.year()) {
      return moment(time).format('HH:mm DD/MM')
    }

    return moment(time).format('HH:mm DD/MM/YYYY')
  }


  render() {
    let { ...props } = this.props;
    let txtDate = '';
    let type_code = props.typecode;
    const hideUpdatedTime = props.hideUpdatedTime;
    const hideText = props.hideText;
    moment.locale('vi');
    timeago.register('cms', cms);
    switch (type_code) {
      case 'draft':
        // txtDate = 'Sửa đổi lần cuối ' + moment(props.updated_at).format('HH:mm DD/MM/YYYY');
        if(props.published_at){
          txtDate = moment(props.published_at).format('DD/MM/YYYY HH:mm');  
        }
        else{
          txtDate = moment(props.updated_at).format('DD/MM/YYYY HH:mm');
        }
        break;
      case 'waiting':
        // txtDate = 'Sửa đổi lần cuối ' + moment(props.updated_at).format('HH:mm DD/MM/YYYY');
        txtDate = moment(props.updated_at).format('DD/MM/YYYY HH:mm');
        break;
      case 'schedule':
        // txtDate = 'Đã lên lịch ' +( props.scheduled ? moment(props.scheduled).format('HH:mm DD/MM/YYYY') : 'cần update');
        txtDate = (props.scheduled ? moment(props.scheduled).format('DD/MM HH:mm') : 'cần update');
        break;
      case 'ready':
        // txtDate = 'Đã đăng ' + moment(props.updated_at).format('HH:mm DD/MM/YYYY');
        txtDate = moment(props.published_at).format('DD/MM/YYYY HH:mm');
        break;
      case 'trash':
        // txtDate = 'Sửa đổi lần cuối ' + moment(props.updated_at).format('HH:mm DD/MM/YYYY');
        txtDate = moment(props.updated_at).format('DD/MM/YYYY HH:mm');
        break;
      default:
        txtDate = '';
        break;
    }

    const updatedDiffHour = moment().diff(moment(props.updated_at), 'hours');
    const updatedTime = this.convertDate(props.updated_at);

    let publishedTime = '';
    if (props.published_at) {
      publishedTime = this.convertDate(props.published_at);
    }

    return (
      <>
        {type_code === 'schedule' &&
          <div>
            <span>Lên lịch </span>
            {this.renderTime(props.scheduled)}
          </div>
        }

        {(type_code === 'ready' || props.published_at) &&
          <div>
            {!hideText && <span>Đã đăng </span>}
            {this.renderTime(props.published_at)}
          </div>
        }
        {!hideUpdatedTime &&
          <div className={this.props.className}>
            <span>Cập nhật </span>
            {this.renderTime(props.updated_at)}
          </div>
        }

      </>
    )
  }
}

export default Date
